import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { HubConnection } from '../service/chatHubService.service';
import { ToastrService } from 'ngx-toastr';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
const FileSaver = require('file-saver');

@Component({
  selector: 'app-chat-files',
  templateUrl: './chat-files.component.html',
  styleUrls: ['./chat-files.component.scss']
})

export class ChatFilesComponent implements OnInit {

  currentUser: any;
  organizationId: string;
  databaseId: string;
  clickEventsubscription:any;
  clickEventsubscriptions:any;

  participantDetails:any=[];
  participantList:any[] = [];
  peoples:any[] = []; 

  doneButtonShow:boolean=false;
  responseHolder: any;
  roomId:any;
  selectedUser:any[] = [];
  users:any[] = [];
  Files :any[] = [];
  spinner:boolean=false;
  isGroup:boolean=false;

  constructor(private dialog: MatDialog,private loaderService: LoaderService,
    private ChatsignalRconnaction:HubConnection,private toastr: ToastrService,
    private statusConst: StatusConstant,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private _dataSharingService: DataSharingService) { 
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
  }

  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();
    this.clickEventsubscriptions.unsubscribe();
  }

  ngOnInit(): void {
    this.isGroup=true;
    this.clickEventsubscription = this._dataSharingService.getSelectedChatParticipant().subscribe((result) => {   
      if(result){ 
        this.participantDetails=result;
        this.participantList=this.participantDetails.users;
        if(this.participantList!=undefined && this.participantList!=null){
          this.peoples=this.participantList;
        }       
        this.organizationId=this.participantDetails.organizationId;
        this.roomId=this.participantDetails.id;
        this.isGroup= this.participantDetails.isOnetoOne;
        }
        this.Files=[];
        //this.GetAttachementsListForRoomId();
     });
    
     this.clickEventsubscriptions = this._dataSharingService.getAddAttachmentFile().subscribe((result) => {   
      if(result){ 
        this.GetAttachementsListForRoomId();
      }
     });
  }


  allParticipants(templateRef: TemplateRef<any>) {
    if(this.peoples?.length > 0){
      const dialogRef = this.dialog.open(templateRef,{
        panelClass: 'custom-modalbox'
      });
      this.peoples.forEach(e => {      
        e.isDeleted=false
       });
       this.selectedUser=[];
       this.doneButtonShow=false;
    }   
  }


  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  close() {
    this.selectedUser=[];
    this.doneButtonShow=false;
    this.dialog.closeAll();
  }

  DeleteUser(user){
    var req={
     userId: user.userId,
     userName: user.userName,
     organizationId: user.organizationId,
     profileImageUrl: user.profileImageUrl,
     email: user.email,
    }
    this.selectedUser.push(req);
    if(this.selectedUser.length>0){
      let removeIndex = this.peoples.findIndex((itm) => itm.userId === user.userId);
      if (removeIndex !== -1) {
        this.peoples.find((itm) => itm.userId === user.userId).isDeleted = true;      
        this.doneButtonShow=true;
    }
   }

   var checklastUser= this.peoples.filter((itm) => itm.isDeleted === false);
    if(checklastUser.length==0){
       this.dialog.closeAll();
       this.DeleteGroup();
    }

  }

  DeleteGroup() {
    const message = `Are you sure you want to delete this group?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm); 
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
     panelClass: 'edituserdetails',
     maxWidth: '1000px',
     maxHeight: '500px',
     data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
         this.loaderService.show();
         var ReqModel={
           roomId: this.roomId,
           user: this.selectedUser,
           isAdd: false,
           updatedBy:  this.currentUser.UID,
           organisationId: this.organizationId
         }
         this.loaderService.show();  
         this.ChatsignalRconnaction.AddOrRemoveUserFromChatRoom(ReqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.close();
              this._dataSharingService.sendDeleteChatGroup(true);
              //this.GetAllRoomsforUser();
              this.toastr.success('Group remove successfully.', '', {
               timeOut: 3000,
               });
               }else{
               this.close()
               this.loaderService.hide();
               }        
              } else {
               this.close()
               this.loaderService.hide();
             }
           });      
        }
      } catch (e) {
       Observable.throw(e);
     }
   });
  }

 
  DeleteParticipant() {
   const message = `Are you sure you want to delete this group participant ?`;
   const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    panelClass: 'edituserdetails',
    maxWidth: '1000px',
    maxHeight: '500px',
    data: dialogData,
   });
   dialogRef.beforeClosed().subscribe(async (dialogResult) => {
     try {
       if (dialogResult) {
        this.loaderService.show();
        var ReqModel={
          roomId: this.roomId,
          user: this.selectedUser,
          isAdd: false,
          updatedBy:  this.currentUser.UID,
          organisationId: this.organizationId
        }
        this.loaderService.show();
        this.ChatsignalRconnaction.AddOrRemoveUserFromChatRoom(ReqModel).subscribe((response) => {
         if (response != undefined) {
           this.responseHolder = response;
           if (this.responseHolder.status == this.statusConst.statusSuccess) {
             this.loaderService.hide();
             this._dataSharingService.sendDeleteChatGroup(true);
             this.close();
             this.GetAllRoomsforUser();
             this.toastr.success('Group participant remove successfully.', '', {
              timeOut: 3000,
              });
              }else{
              this.close()
              this.loaderService.hide();
              }        
             } else {
              this.close()
              this.loaderService.hide();
            }
          });      
       }
     } catch (e) {
      Observable.throw(e);
    }
  });
  }

  GetAllRoomsforUser() {
    var ReqModel={
    //  userId:this.currentUser.UID
    email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
    }
   this.ChatsignalRconnaction.GetAllRoomsforUser(ReqModel).subscribe((response) => {
    if (response != undefined) {
      this.loaderService.hide();
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
       this.users=response.data.filter(p=>p.id==this.roomId);
       if(this.users.length>0){
         this.participantDetails=this.users[0];
         this.participantList=this.participantDetails.users;
         this.peoples=this.participantList;
         this.organizationId=this.participantDetails.organizationId;
         this.roomId=this.participantDetails.id;      
         }else{
           this.GetAllRoomsforUserNew();
         }
        }else{
          this.loaderService.hide();
        }
       } else {
        this.loaderService.hide();
      }
    });
  }
  
  GetAllRoomsforUserNew() {
    var ReqModel={
    //  userId:this.currentUser.UID
    email:((sessionStorage.getItem('email')==null || sessionStorage.getItem('email')==undefined)?sessionStorage.getItem('portalemail'):sessionStorage.getItem('email'))
     
   }
   this.ChatsignalRconnaction.GetAllRoomsforUser(ReqModel).subscribe((response) => {
    if (response != undefined) {
      this.loaderService.hide();
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {      
         this.participantDetails= this.responseHolder.data[0];
         this.participantList=this.responseHolder.data[0].users;
         this.peoples=this.participantList;
         this.organizationId=this.participantDetails.organizationId;
         this.roomId=this.participantDetails.id;   
        }else{
          this.loaderService.hide();
        }
       } else {
        this.loaderService.hide();
      }
    });
  }  


  GetAttachementsListForRoomId() {
    var ReqModel={
      roomId: this.roomId,
      pageIndex: 0,
      pageSize: 100,
      daysOld: 30
   }
   this.ChatsignalRconnaction.GetAttachementsListForRoomId(ReqModel).subscribe((response) => {
    if (response != undefined) {    
      this.responseHolder = response;
      if (this.responseHolder.status == this.statusConst.statusSuccess) {      
        this.Files=this.responseHolder.data.messages;
        if(this.Files.length > 0){
          this.Files.map((res) => {
            if (res.fileName != null) {
              res.fileName = res.fileName.replace(/\..+$/, '');
            }              
            return res;
          });
        }
        }else{
        }
       } else {
      }
    });
  }  

  DownloadFile(doc: any) {    
    this.spinner=true;
    this.ChatsignalRconnaction.getAttachment(doc.fileName, doc.filePath).subscribe((response) => {
    if (response !== undefined) {
        const data = 'data:' + response.data.contentType +';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, doc.fileName);
        this.spinner=false;
       }else{
        this.spinner=false;
       }
    });
   }  
  
  
}
